// extracted by mini-css-extract-plugin
export default {"container":"SinglePrice_container__Snzcu"};